import authRepository from '@/repositories/auth.repository';
import { useMutation } from '@tanstack/react-query';

export function useSignInMutation() {
  return useMutation({
    mutationFn: authRepository.signIn,
  });
}

export function useVerifyOTPMutation() {
  return useMutation({
    mutationFn: authRepository.verifyOTP,
  });
}
